import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from 'services/api/config/api';
import { AgentCallConsole } from '../AgentCallConsole';
import { useAgentCallConsole } from '../AgentCallConsole/hooks/useAgentCallConsole';
import { UserRound } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { AgentCallStatus } from './components';
import { useGetPartyStages } from 'services/hooks/queries';
import { startOfDay, endOfDay } from 'date-fns';
import { useGetManagerCenterData } from 'services/hooks/queries';
import { Button } from 'common/components';
import { UserRole, hasAnyRole } from 'types/userRoles';

const TopBar = () => {
    const [openAgentConsole, setOpenAgentConsole] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const { userRoles } = useAuth();
    const isSuperAdmin = hasAnyRole(userRoles, [UserRole.SUPER_ADMIN]);
    useGetPartyStages(!isSuperAdmin);
    // Use the comprehensive hook for all functionality
    const callData = useAgentCallConsole();

    const startOfDate = startOfDay(new Date());
    const endOfDate = endOfDay(new Date());

    const isManager = hasAnyRole(userRoles, [UserRole.MANAGER, UserRole.SUPER_ADMIN, UserRole.ADMIN]);
    const { managerCenterData } = useGetManagerCenterData(
        {
            startDate: startOfDate,
            endDate: endOfDate,
        },
        !!isManager,
        60000 * 5 // 5 minutes interval
    );

    // Map specific paths to their corresponding page titles.
    // Adjust or expand these mappings as needed.
    const routeTitles: Record<string, string> = {
        '/dashboard': 'Dashboard',
        '/campaigns': 'Campaigns',
        '/smart-dialer': 'Smart Dialer',
        '/slai-training': 'SLAI Training Portal',
        '/settings': 'Settings',
    };

    // Determine the title based on the current pathname.
    // If the pathname is not found in our mapping, default to "Dashboard".
    const pageTitle = routeTitles[location.pathname] || 'Dashboard';
    const isAgent = userRoles.includes(UserRole.AGENT);

    // Handle Logout
    const handleLogout = async () => {
        try {
            await api.post('/auth/logout');
        } catch (error) {
            console.error('Logout error:', error);
        }
        navigate('/login');
    };

    useEffect(() => {
        if (callData.shouldCloseCallConsole) {
            setOpenAgentConsole(false);
            callData.setShouldCloseCallConsole(false);
        }
    }, [callData.shouldCloseCallConsole]);

    return (
        <header className='top-bar'>
            <div className='top-bar__left'>
                {/* <h1>{pageTitle}</h1> */}
                {/*  <button className="export-btn">Export</button>*/}
            </div>
            <div className='top-bar__right'>
                {/*TODO: Hide temporarily*/}
                {/*<input*/}
                {/*    type="text"*/}
                {/*    placeholder="Search..."*/}
                {/*    className="search-bar"*/}
                {/*/>*/}
                {isManager && (
                    <div className='text-small'>Online agents: {managerCenterData?.metrics?.online_agents}</div>
                )}
                <div className='top-bar__icons'>
                    {/*TODO: Hide temporarily*/}
                    {/*<button className="icon-button bell-icon">*/}
                    {/*    <img src="/icons/notif.png" alt="Bell Icon" />*/}
                    {/*</button>*/}
                    {isAgent ? (
                        <AgentCallStatus callData={callData} setOpenAgentConsole={setOpenAgentConsole} />
                    ) : (
                        <Button variant='outline-secondary' isRounded size='sm' iconOnly icon={UserRound} />
                    )}
                </div>

                <Button variant='outline-primary' size='sm' onClick={handleLogout}>
                    Logout
                </Button>
            </div>
            <AgentCallConsole onClose={() => setOpenAgentConsole(false)} isOpen={openAgentConsole} {...callData} />
        </header>
    );
};

export default TopBar;
